import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IReserveBreakdown } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getIncomeUSDBreakdownConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_reserves_breakdown', timeframe)) as IReserveBreakdown[]

	const series4 = chartData
		.filter((element: IReserveBreakdown) => new Date(element.DAY).getTime() >= new Date('2025-04-01').getTime())
		.map((element: IReserveBreakdown) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.NETWORK_FEE }
		})
	const series5 = chartData
		.filter((element: IReserveBreakdown) => new Date(element.DAY).getTime() >= new Date('2025-04-01').getTime())
		.map((element: IReserveBreakdown) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.OUTBOUND_FEE }
		})

	const series7 = chartData
		.filter((element: IReserveBreakdown) => new Date(element.DAY).getTime() >= new Date('2025-04-01').getTime())
		.map((element: IReserveBreakdown) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.RESERVE_INCOME }
		})
	const series1 = chartData
		.filter((element: IReserveBreakdown) => new Date(element.DAY).getTime() >= new Date('2025-04-01').getTime())
		.map((element: IReserveBreakdown) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.RESERVE_INCOME_CUMULATIVE }
		})
	const series8 = chartData
		.filter((element: IReserveBreakdown) => new Date(element.DAY).getTime() >= new Date('2025-04-01').getTime())
		.map((element: IReserveBreakdown) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.SLASHING_INCOME }
		})
	const series9 = chartData
		.filter((element: IReserveBreakdown) => new Date(element.DAY).getTime() >= new Date('2025-04-01').getTime())
		.map((element: IReserveBreakdown) => {
			if (new Date(element.DAY).getTime() / 1000 <= 1743415200) {
				return { x: new Date(element.DAY).getTime() / 1000, y: 0 }
			} else {
				return { x: new Date(element.DAY).getTime() / 1000, y: element.LIQ_FEES_RUNE }
			}
		})

	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'cumulative',
			type: 'line',
			seriesGroup: ' [rune]',
			color: `${color}`,
			unitSymbol: 'ᚱ'
		},
		{
			data: series9,
			strokeWidth: 2,
			name: 'liquidity fees',
			type: 'bars',
			seriesGroup: '[rune]',
			color: 'orange',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'network fee',
			type: 'bars',
			seriesGroup: '[rune]',
			color: 'green',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'outbound fee',
			type: 'bars',
			seriesGroup: '[rune]',
			color: '#0ffc03',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'slashing',
			type: 'bars',
			seriesGroup: '[rune]',
			color: 'yellow',
			unitSymbol: 'ᚱ',
			barGroup: 's'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'total',
			type: 'line',
			seriesGroup: '[rune]',
			color: `${inverseColor}`,
			unitSymbol: 'ᚱ'
		}
	]

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const IncomeUSDBreakdown = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getIncomeUSDBreakdownConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Protocol Income Breakdown"
			chartDesc={`Breakdown of the THORChain protocol earnings. 
				\n Income sources: liquidity fees (swaping etc.), network fees (currently 0.02 RUNE per transaction), node slashing (network earns RUNE when a node misbehaves), outbound fee (network transaction fee when sending swap outputs to different blockchains). 
				`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="b169abba-2dea-439c-9715-e0a0a4ae0319"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default IncomeUSDBreakdown
